import React, { useEffect, useState } from "react";
import { makeStyles, Grid } from "@material-ui/core";
import Header from "../header";
import HeaderWidgets from "./components/team-header/HeaderWidgets";
import { useSelector } from "react-redux";
import { getSelectedTeamId } from "../../store/ui/selectedTeam";
import Team from "./components/Team";
import Birdseye from "./components/Birdseye";
import { getTeamById } from "../../store/hub/teams";
import TeamRoomTicker from "./components/Ticker";
import { getTickerEntries } from "../../store/hub/ticker";
import TimePeriodSelector from "./components/birdseye/TimePeriodSelector";
import HubViewToggle from "./components/HubViewToggle";

export default function TeamOverview() {

  const classes = useStyles();
  const [view, setView] = useState("Hub Overview");
  const selectedTeamId = useSelector(getSelectedTeamId)();
  const selectedTeam = useSelector(getTeamById)(selectedTeamId);
  const tickerEntries = useSelector(getTickerEntries)();
  const hasTeam = selectedTeamId != null && selectedTeamId !== -1;

  useEffect(() => {
    // No primary team: Overview is shown — keep the toggle in sync.
    if (selectedTeamId === -1) {
      setView("Hubs");
    }
  }, [selectedTeamId]);

  const updateTeamView = (newView) => {
    if (newView === "Hub Overview" && !hasTeam) return;
    if (view !== newView) setView(newView);
  };

  const additionalHeaderHtml = (view) => {
    return (
      <>
      {view === "Hubs" || view === "Hub Overview" ? (
        <TimePeriodSelector></TimePeriodSelector>
      ) : null}
      </>
    );
  };

  return (
    <>
      <Header
        actions={[]}
        leading={
          <HubViewToggle
            view={view}
            onChange={updateTeamView}
            hubDisabled={!hasTeam}
          />
        }
        additional={additionalHeaderHtml(view)}
      />
      <Grid
        container
        className={classes.root}
        spacing={2}
        style={{ marginBottom: tickerEntries.length >= 1 ? 150 : 0 }}
      >
        {view === "Hub Overview" && selectedTeam ? (
          <>
            <HeaderWidgets selectedTeam={selectedTeam} />
            <Team selectedTeam={selectedTeam} />
          </>
        ) : null}
        {view === "Hubs" || selectedTeamId === -1 ? (
          <Birdseye updateTeamView={updateTeamView} />
        ) : null}
      </Grid>
      <TeamRoomTicker />
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    alignItems: "flex-start",
    alignContent: "flex-start",
  },
}));
